import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
export var State =
/*#__PURE__*/
function () {
  function State() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _classCallCheck(this, State);

    this.value = value;
  }

  _createClass(State, [{
    key: "create",
    value: function create(value) {
      return new this.constructor(value);
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      return this.create(value);
    }
  }, {
    key: "clear",
    value: function clear() {
      return this.create(null);
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.value;
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      return !!this.value;
    }
  }]);

  return State;
}();